import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { TableContext } from '../../../components/Table/TableContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';
import useBaVerificationStatsCard from './useBaVerificationStatsCard';

const useBaDriverVerification = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const tableContext = useContext(TableContext);
  const { getBaVerificationStats } = useBaVerificationStatsCard();

  const onConfirmBADriverVerificationError = (
    err: AxiosError<ErrorHttpResponse>,
  ) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while confirming profile.',
    );
    // setShowSuccessModal(true);
  };

  const onConfirmBADriverVerificationSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    tableContext?.setRefreshTable(!tableContext?.refreshTable);
    getBaVerificationStats();
  };

  const toggleBADriverVerification = async (id: any, status: string) => {
    const url: HttpConfig = {
      url: `ba/v1/drivers/onboarding/update-status/${id}`,
      method: 'put',
      data: { status }
    };

    await request(
      url,
      onConfirmBADriverVerificationSuccess,
      setLoading,
      onConfirmBADriverVerificationError,
    );
  };

  return {
    toggleBADriverVerification,
    loading,
  };
};

export default useBaDriverVerification;
